import { Injectable } from '@angular/core';
import { action, observable } from 'mobx-angular';
import { makeObservable } from '../utils/mobx';
import { BaseStore } from './base.store';

@Injectable({
  providedIn: 'root',
})
export class WindowStore extends BaseStore {
  @observable
  private version = 0;
  @observable
  private _window: Window = window;

  @action
  changeWindow = (w: Window) => {
    this._window = w;
    this.version++;
  };

  get window(): Window {
    // eslint-disable-next-line
    this.version;
    return this._window;
  }

  constructor() {
    super();
    makeObservable(this);
  }
}
